// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CreditCardFilledSvg from "@fishx/icons-svg/es/asn/CreditCardFilled";
import FishxIcon from '../components/FishxIcon';

var CreditCardFilled = function CreditCardFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CreditCardFilledSvg
  }));
};

CreditCardFilled.displayName = 'CreditCardFilled';
export default React.forwardRef(CreditCardFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CreditCardFilled.js
// module id = 2337
// module chunks = 0